function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { useContext } from 'react';
import { DndContext } from 'react-dnd';

var useForBackend = function useForBackend(spec, fn, manager, backend) {
  var previous = manager.getBackend();
  manager.receiveBackend(backend);
  var result = fn(spec);
  manager.receiveBackend(previous);
  return result;
};

export var useMultiCommon = function useMultiCommon(spec, fn) {
  var _dndContext$dragDropM;

  var dndContext = useContext(DndContext);
  var dndBackend = dndContext === null || dndContext === void 0 ? void 0 : (_dndContext$dragDropM = dndContext.dragDropManager) === null || _dndContext$dragDropM === void 0 ? void 0 : _dndContext$dragDropM.getBackend();

  if (dndBackend === undefined) {
    throw new Error('could not find backend, make sure you are using a <DndProvider />');
  }

  var result = fn(spec);
  var multiResult = {};
  var backends = dndBackend.backendsList();

  var _iterator = _createForOfIteratorHelper(backends),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _backend = _step.value;
      multiResult[_backend.id] = useForBackend(spec, fn, dndContext.dragDropManager, _backend.instance);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return [result, multiResult];
};